module.exports = __webpack_public_path__ + "img/20200217201822432.3a20977e.jpg";